<div [attr.data-sb-qa]="qaTag" class="chip-button-select" [ngClass]="{'w-100': stretch}">
    <mat-select *ngIf="!loading" [ngClass]="{'chip-button-select-desktop': !isMobile || disableBottomSheet, 'chip-button-select-mobile': isMobile && !disableBottomSheet, 'chip-button-stretch' : stretch,
        'scss-chip-button-no-border': disableBorder}"
        [value]="selected?.value"
        disableRipple
        (selectionChange)="SelectionChange($event)"
        (click)="$event.stopPropagation()"
        panelClass="scss-chip-button-select">

        <mat-select-trigger *ngIf="!isMobile || disableBottomSheet">
            <ng-container *ngTemplateOutlet="triggerTemplate; context:{$implicit:selected?.value}"></ng-container>
        </mat-select-trigger>

        <ng-container *ngFor="let option of chipOptions">
            <mat-divider class="my-2" *ngIf="option.menuDivider == MenuDivider.Above"></mat-divider>
            <mat-option class="chip-button-option" [value]="option.value">
                <div class="d-flex w-100">
                    <ng-container *ngTemplateOutlet="option.content"></ng-container>
                    <div *ngIf="selected?.value != option.value" class="ms-5"></div>
                </div>
            </mat-option>
        </ng-container>
    </mat-select>

    <lib-chip-button *ngIf="isMobile && !disableBottomSheet && !loading" [hasCarretSuffix]="true" (click)="OpenBottomSheet()">
        <ng-container *ngTemplateOutlet="triggerTemplate; context:{$implicit:selected?.value}"></ng-container>
    </lib-chip-button>

    <lib-chip-button *ngIf="loading" [hasCarretSuffix]="false">
        <div class="spinner-border spinner-border-xs color-brand"></div>
        <p class="typography-label-large base-300 px-1 text-truncate" i18n="@@CommonLoadingEllipsis">Loading...</p>
    </lib-chip-button>
</div>
